import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


const SettingsBreadcrumb = ({ items = [], company, isAdminMode }) => {
  const breadcrumbItems = [];

  if (isAdminMode && company) {
    breadcrumbItems.push({ label: 'Companies', path: '/companies' });
    breadcrumbItems.push({ label: company.name, path: `/settings?companyId=${company.id}` });
  } else {
    breadcrumbItems.push({ label: 'Settings', path: '/settings' });
  }

  items.forEach((item) => {
    breadcrumbItems.push(item);
  });

  return (
    <nav className="settings-breadcrumb">
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;

        return (
          <React.Fragment key={index}>
            {isLast ? (
              <span className="settings-breadcrumb__item settings-breadcrumb__item--active">
                {item.label}
              </span>
            ) : (
              <>
                <Link to={item.path} className="settings-breadcrumb__item settings-breadcrumb__link">
                  {item.label}
                </Link>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="settings-breadcrumb__separator"
                />
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default SettingsBreadcrumb;
